import { createSlice } from '@reduxjs/toolkit';
import { sar } from '../../../helpers/reduxHelper';

const initialData = () => ({
  name: '',
  preview_type: 'Interactive',
  sceneId: '',
  labels: [], // [{id: <labelId>, items: <itemsId>}]
  cameraId: '',
})

const getInitialState = () => ({
  data: initialData(),
  activeTab: 'Interactive',
  previewInProgress: 1,
  previewCompleted: 3,
})

const configuratorPreview = createSlice({
  name: 'configuratorPreview',
  initialState: getInitialState(),
  reducers: {
    resetState: () => {
      return getInitialState();
    },
    setData: (state, { payload }) => {
      state.data = JSON.parse(JSON.stringify(payload))
    },
    updateData: (state, { payload }) => {
      const { key, value } = payload;
      state.data[key] = value;
    },
    setActiveTab: (state, { payload }) => {
      state.activeTab = payload;
      state.data['preview_type'] = payload;
    },
    setInProgressPreviewCount: sar('previewInProgress'),
    setCompletedPreviewCount: sar('previewCompleted'),
  },
});

export const configuratorPreviewActions = configuratorPreview.actions;
export const configuratorPreviewReducer = configuratorPreview.reducer;

export const selectPreviewData = (state) => state.configuratorPreview.data;
export const selectPreviewActiveTab = (state) => state.configuratorPreview.activeTab;
export const selectPreviewInProgress = (state) => state.configuratorPreview.previewInProgress;
export const selectPreviewCompleted = (state) => state.configuratorPreview.previewCompleted;